<template>
  <div class="tw:flex tw:items-center tw:gap-1" @mouseleave="hovered = null">
    <button
      v-for="star in maxRating"
      :key="star"
      type="button"
      class="tw:border-none tw:bg-transparent tw:p-0 tw:flex tw:items-center tw:cursor-pointer disabled:tw:cursor-default"
      :disabled="readOnly"
      @mouseover="!readOnly && (hovered = star)"
      @click="!readOnly && selectStar(star)"
    >
      <IconGoogle
        name="star"
        :size="`${starSize}px`"
        :fill="(hovered ?? rating) >= star"
        :color="(hovered ?? rating) >= star ? 'var(--rating-gold-500, #f5a623)' : 'var(--neutral-gray-300, #d1d5db)'"
      />
    </button>
    <span
      v-if="showRating && rating > 0"
      class="tw:text-sm tw:font-semibold"
      style="color: var(--rating-gold-500, #f5a623)"
    >
      {{ rating.toFixed(1) }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import IconGoogle from '../../atoms/IconGoogle/IconGoogle.vue'

withDefaults(defineProps<{
  rating?: number
  maxRating?: number
  starSize?: number
  showRating?: boolean
  readOnly?: boolean
}>(), {
  rating: 0,
  maxRating: 5,
  starSize: 20,
  showRating: true,
  readOnly: false,
})

const emit = defineEmits<{
  'rating-selected': [value: number]
  'update:rating': [value: number]
}>()

const hovered = ref<number | null>(null)

function selectStar(star: number) {
  emit('rating-selected', star)
  emit('update:rating', star)
}
</script>
